document.addEventListener('click', function (event) {
  const modal = document.getElementById('priceRequestModal');
  if (!modal) return;
  // Open popup: Price on Request button
  const openButton = event.target.closest('.price-request-btn');
  if (openButton) {
    event.preventDefault();
    const priceElement = openButton.closest('.suggest-item')?.querySelector('.price-item-regular');
    const title =
      priceElement?.getAttribute('data-title') ||
      openButton.getAttribute('data-title') ||
      '';

    const sku =
      priceElement?.getAttribute('data-sku') ||
      openButton.getAttribute('data-sku') ||
      '';
    
     // Product title field
    const titleField = modal.querySelector('#ContactForm-title');

    if (titleField) {
      titleField.value = title;
      titleField.dispatchEvent(new Event('input', { bubbles: true }));
      titleField.dispatchEvent(new Event('change', { bubbles: true }));
    }

      // Product SKU field
    const skuField = modal.querySelector('#ContactForm-sku');

    if (skuField) {
      skuField.value = sku;
      skuField.dispatchEvent(new Event('input', { bubbles: true }));
      skuField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Find message/comment field
    const messageField = modal.querySelector(
      '#ContactForm-body, textarea[name="contact[body]"]'
    );

    if (messageField) {
      messageField.value =
        `Hi Team,\n\n\nI'm interested in the product Above and would love to get your best trade price!.\n\nCould you please share your best quotation, along with current stock availability and delivery details?\n\nLooking forward to hearing from you!\n\nThanks!`;

      messageField.dispatchEvent(new Event('input', { bubbles: true }));
      messageField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    return;
  }
  // Close popup: Close button or overlay
  if (
    event.target.closest('.price-request-close') ||
    event.target.classList.contains('price-request-overlay')
  ) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }
});
// Close popup with Escape key
document.addEventListener('keydown', function (event) {
  const modal = document.getElementById('priceRequestModal');

  if (event.key === 'Escape' && modal && !modal.hidden) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }
});

